
import { Box, Copy, Flex, HorizontalRule } from '@elparking/components'
import { CALENDAR_DATETIME_SHORT_FORMAT, YEAR_FORMAT, HOUR_FORMAT } from 'commons/js/constants'
import DateTime from 'commons/js/ui/DateTime'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
export const BookingDatesInfo = ({startRent, endRent, timeZone}) => <Flex flexDirection={['column', 'row']}>
    <Box pr={['0px', '24px']} pb={['24px', '0px']}>
        <Copy fontSize='xSmall' fontWeight='regular' padding='0'><FormattedMessage defaultMessage='Recogida' /></Copy>
        <Copy fontSize={['large', 'xxLarge']} fontWeight='bold' padding='4px 0px'>
            <DateTime value={startRent.date} format={CALENDAR_DATETIME_SHORT_FORMAT} timeZone={timeZone} />
            <Copy as='span' fontSize={['large', 'medium']} fontWeight='bold' padding='0px 4px 0px 0px'><DateTime value={startRent.date} format={YEAR_FORMAT} timeZone={timeZone}/>,</Copy>
            <Copy as='span' fontSize={['large', 'medium']} fontWeight='bold'><DateTime value={startRent.date} format={HOUR_FORMAT} timeZone={timeZone}/></Copy>
        </Copy>
        {startRent.place && <Copy fontSize='small' fontWeight='regular' padding={['0px', 'auto']}>{startRent.place.stationName}</Copy>}
    </Box>
    {endRent.date && <Box display={['none', 'block']} pb={['24px', '0px']}><HorizontalRule.vertical margin='0' height='100%' background='lightGray40'/></Box>}
    {endRent.date && <Box pl={['0px', '24px']}>
        <Copy fontSize='xSmall' fontWeight='regular' padding='0'><FormattedMessage defaultMessage='Devolución' /></Copy>
        <Copy fontSize={['large', 'xxLarge']} fontWeight='bold' padding='4px 0px'>
            <DateTime value={endRent.date} format={CALENDAR_DATETIME_SHORT_FORMAT} timeZone={timeZone}/>
            <Copy as='span' fontSize={['large', 'medium']} fontWeight='bold' padding='0px 4px 0px 0px'><DateTime value={endRent.date} format={YEAR_FORMAT} timeZone={timeZone}/>,</Copy>
            <Copy as='span' fontSize={['large', 'medium']} fontWeight='bold'><DateTime value={endRent.date} format={HOUR_FORMAT} timeZone={timeZone}/></Copy>
        </Copy>
        {endRent.place && <Copy fontSize='small' fontWeight='regular' padding={['0px', 'auto']}>{endRent.place.stationName}</Copy>}
    </Box>}
</Flex>

BookingDatesInfo.propTypes = {
    startRent: PropTypes.shape({
        date: PropTypes.number,
        place: PropTypes.shape({
            stationName: PropTypes.string,
        }),
    }),
    endRent: PropTypes.shape({
        date: PropTypes.number,
        place: PropTypes.shape({
            stationName: PropTypes.string,
        }),
    }),
    timeZone: PropTypes.string,
}

export default BookingDatesInfo
